import React from 'react';
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';
import { MOTOR_TYPES } from '../../../../constants';
import { formatPrice } from '../../../../utils';
import { handleNumericKeyDown, customSelectStyles } from '../OrderFormUtils';

const KatlamaliForm = ({
  newOrder,
  onFieldChange,
  isLoading,
  productItems,
  productOptions,
  handleProductSelect,
  adminSettings,
  selectedProductType,
  handleMotorTypeChange,
  handleKatlamaliMechanismSelect,
  handleAddAccessory,
  handleAccessoryChange,
  handleRemoveAccessory
}) => {
  return (
    <>
      <div className="form-group">
        <label>Oda Adı *</label>
        <input type="text" value={newOrder.roomName || ''} onChange={(e) => onFieldChange('roomName', e.target.value)} required disabled={isLoading} />
      </div>

      <div className="form-group">
        <label>Ürün Adı *</label>
        <CreatableSelect
          options={productOptions}
          value={
            (productOptions && productItems) ? 
              productOptions.find(o => o.value === (productItems.find(p => p.name === newOrder.productName)?.id)) ||
              (newOrder.productName ? { value: newOrder.productName, label: newOrder.productName } : null)
            : (newOrder.productName ? { value: newOrder.productName, label: newOrder.productName } : null)
          }
          onChange={(option) => {
            if (!option) {
              onFieldChange('productName', '');
              onFieldChange('unitPrice', '');
            } else if (option.__isNew__) {
              onFieldChange('productName', option.value);
              onFieldChange('unitPrice', '');
            } else {
              handleProductSelect(option.value);
            }
          }}
          isDisabled={isLoading} isClearable isSearchable placeholder="Ürün seçin veya yazın..." noOptionsMessage={() => "Ürün bulunamadı"} formatCreateLabel={(inputValue) => `"${inputValue}" olarak ekle`} styles={customSelectStyles}
        />
      </div>

      <div className="form-group">
        <label>Ürün Varyantı</label>
        <input
          type="text"
          value={newOrder.productVariant || ''}
          onChange={(e) => onFieldChange('productVariant', e.target.value)}
          disabled={isLoading}
          placeholder="Renk, desen vb. giriniz..."
        />
      </div>

      <div className="form-group">
        <label>En (cm) *</label>
        <input type="number" step="0.01" value={newOrder.width || ''} onKeyDown={handleNumericKeyDown} onChange={(e) => onFieldChange('width', e.target.value)} required disabled={isLoading} />
      </div>

      <div className="form-group">
        <label>Boy (cm) *</label>
        <input type="number" step="0.01" value={newOrder.height || ''} onKeyDown={handleNumericKeyDown} onChange={(e) => onFieldChange('height', e.target.value)} required disabled={isLoading} />
      </div>

      {newOrder.width && (
        <div className="form-group">
          <label>Kullanılan Mt</label>
          <input type="text" value={newOrder.usedM || '0.00'} readOnly className="readonly-field" />
        </div>
      )}

      <div className="form-group">
        <label>Kumaş (₺) *</label>
        <input type="number" step="0.01" min="0.01" value={newOrder.fabricPrice || ''} onKeyDown={handleNumericKeyDown} onChange={(e) => onFieldChange('fabricPrice', e.target.value)} required disabled={isLoading} />
      </div>

      <div className="form-group">
        <label>Mekanizma Tipi *</label>
        {adminSettings?.katlamaliMekanizmaList && adminSettings.katlamaliMekanizmaList.length > 0 ? (
          <Select
            options={adminSettings.katlamaliMekanizmaList.map(m => ({ value: m.type, label: `${m.type} (${m.price} ₺)` }))}
            value={newOrder.mechanismType ? { value: newOrder.mechanismType, label: newOrder.mechanismType } : null}
            onChange={(option) => handleKatlamaliMechanismSelect(option ? option.value : '')}
            isDisabled={isLoading} isClearable isSearchable placeholder="Seçiniz..." styles={customSelectStyles}
          />
        ) : (
          <input type="text" value={newOrder.mechanismType || ''} onChange={(e) => onFieldChange('mechanismType', e.target.value)} disabled={isLoading} placeholder="Mekanizma tipi girin" />
        )}
      </div>

      <div className="form-group">
        <label>Mekanizma (₺) *</label>
        <input type="number" step="0.01" min="0.01" value={newOrder.mechanismPrice || ''} onKeyDown={handleNumericKeyDown} onChange={(e) => onFieldChange('mechanismPrice', e.target.value)} required disabled={isLoading} />
      </div>

      <div style={{ gridColumn: '1 / -1', marginTop: '20px', marginBottom: '20px' }}>
        <div className="section-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 15px', backgroundColor: '#f8fafc', borderRadius: '8px 8px 0 0', border: '1px solid #e2e8f0', borderBottom: 'none' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <i className="fas fa-tags" style={{ color: '#0f172a' }}></i>
            <h4 style={{ margin: 0, fontSize: '14px', fontWeight: '600', color: '#1e293b' }}>Aksesuarlar</h4>
          </div>
          <button
            type="button"
            onClick={handleAddAccessory}
            className="btn-add-accessory"
            style={{ display: 'flex', alignItems: 'center', gap: '5px', padding: '6px 12px', backgroundColor: '#0f172a', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '12px', fontWeight: '600' }}
          >
            <i className="fas fa-plus"></i> Aksesuar Ekle
          </button>
        </div>
        <div className="section-body" style={{ padding: '15px', border: '1px solid #e2e8f0', borderRadius: '0 0 8px 8px', backgroundColor: '#fff' }}>
          {(!newOrder.accessories || newOrder.accessories.length === 0) ? (
            <div style={{ textAlign: 'center', padding: '20px', color: '#64748b', fontSize: '13px' }}>Henüz aksesuar eklenmemiş.</div>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              {newOrder.accessories.map((acc) => (
                <div key={acc.id} style={{ display: 'grid', gridTemplateColumns: '1fr 100px 80px 100px 40px', gap: '15px', alignItems: 'center', padding: '12px', backgroundColor: '#f1f5f9', borderRadius: '8px' }}>
                  <div className="form-group-mini">
                    <label style={{ fontSize: '11px', color: '#64748b', marginBottom: '4px', display: 'block' }}>Aksesuar Adı</label>
                    <input type="text" value={acc.name || ''} onChange={(e) => handleAccessoryChange(acc.id, 'name', e.target.value)} placeholder="Aksesuar adı" style={{ width: '100%', padding: '6px 10px', borderRadius: '6px', border: '1px solid #cbd5e1' }} />
                  </div>
                  <div className="form-group-mini">
                    <label style={{ fontSize: '11px', color: '#64748b', marginBottom: '4px', display: 'block' }}>Fiyat (₺)</label>
                    <input type="number" value={acc.price || ''} onChange={(e) => handleAccessoryChange(acc.id, 'price', e.target.value)} placeholder="Fiyat" style={{ width: '100%', padding: '6px 10px', borderRadius: '6px', border: '1px solid #cbd5e1' }} />
                  </div>
                  <div className="form-group-mini">
                    <label style={{ fontSize: '11px', color: '#64748b', marginBottom: '4px', display: 'block' }}>Adet</label>
                    <input type="number" min="1" value={acc.quantity || '1'} onChange={(e) => handleAccessoryChange(acc.id, 'quantity', e.target.value)} placeholder="Adet" style={{ width: '100%', padding: '6px 10px', borderRadius: '6px', border: '1px solid #cbd5e1' }} />
                  </div>
                  <div className="form-group-mini">
                    <label style={{ fontSize: '11px', color: '#64748b', marginBottom: '4px', display: 'block' }}>Tutar (₺)</label>
                    <input type="text" value={formatPrice(acc.total || 0)} readOnly style={{ width: '100%', padding: '6px 10px', borderRadius: '6px', border: '1px solid #cbd5e1', backgroundColor: '#e2e8f0' }} />
                  </div>
                  <button
                    type="button"
                    onClick={() => handleRemoveAccessory(acc.id)}
                    style={{ marginTop: '18px', padding: '8px', backgroundColor: '#fee2e2', color: '#ef4444', border: 'none', borderRadius: '6px', cursor: 'pointer', transition: 'all 0.2s' }}
                    title="Sil"
                  >
                    <i className="fas fa-trash-alt"></i>
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      <div className="form-group">
        <label>Motor</label>
        <select value={newOrder.motorType || ''} onChange={handleMotorTypeChange} disabled={isLoading}>
          <option value="">Seçiniz</option>
          {Object.entries(MOTOR_TYPES).map(([key, value]) => (<option key={key} value={value}>{value}</option>))}
        </select>
      </div>

      {newOrder.motorType && (
        <div className="form-group">
          <label>Motor Ücreti ({adminSettings[`${selectedProductType}MotorCurrency`] || 'USD'})</label>
          <input type="number" step="0.01" value={newOrder.motorPriceCurrency || ''} onChange={(e) => onFieldChange('motorPriceCurrency', e.target.value)} disabled={isLoading} />
          {newOrder.motorPriceCurrency && <small style={{ display: 'block', marginTop: '5px', color: '#b04309' }}>≈ {newOrder.motorPrice ? Number(newOrder.motorPrice).toFixed(2) : 0} ₺</small>}
        </div>
      )}

      <div className="form-group">
        <label>Montaj (₺)</label>
        <input type="number" step="0.01" value={newOrder.mounting || ''} onChange={(e) => onFieldChange('mounting', e.target.value)} disabled={isLoading} />
      </div>

      <div className="form-group">
        <label>Adet *</label>
        <input type="number" min="1" value={newOrder.quantity || ''} onKeyDown={handleNumericKeyDown} onChange={(e) => onFieldChange('quantity', e.target.value)} required disabled={isLoading} />
      </div>

      <div className="form-group">
        <label>İskonto (%)</label>
        <input type="number" min="0" max="100" value={newOrder.discount || ''} onKeyDown={handleNumericKeyDown} onChange={(e) => onFieldChange('discount', e.target.value)} disabled={isLoading} />
      </div>

      {newOrder.productName && (
        <div className="form-group">
          <label>Toplam Tutar (₺)</label>
          <input
            type="text"
            value={formatPrice(newOrder.totalPrice)}
            readOnly
            className="readonly-field total-price"
          />
        </div>
      )}

      {newOrder.discount > 0 && (
        <div className="form-group">
          <label>İndirimli Tutar (₺)</label>
          <input
            type="text"
            value={formatPrice(newOrder.discountedPrice)}
            readOnly
            className="readonly-field discounted-price"
          />
        </div>
      )}
    </>
  );
};

export default KatlamaliForm;
